<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-birthday-sport-offer"
  [activeStep]="1"
  [sectionTitle]="
    translateKey('title', {
      formula_title: offerName,
    })
  "
  [sectionDescription]="translateKey('text')"
  [error$]="error$"
  [loading$]="isLoading$.asObservable()"
  [formGroup]="formGroup"
  (formSubmit)="saveSportOffer($event)"
  [previousUrl]="previousUrl"
  [previousNavigationExtras]="previousNavigationExtras"
  previousQueryParametersHandling="merge"
>
  <fieldset *ngIf="!isFirstOffer" class="mt-8">
    <legend class="text-lg font-bold">
      {{
        translateKey('imported.title', {
          formula_title: previousOfferTitle,
        })
      }}
    </legend>

    <app-tips
      class="block mt-3"
      [title]="translateKey('tips.title')"
      [tips]="
        translateKey('tips.text', {
          formula_title: offerName,
          previous_formula_title: previousOfferTitle,
        })
      "
      [variant]="tipsVariant.WARNING"
    >
    </app-tips>

    <ng-container
      *ngFor="
        let importedSport of importedSports.controls;
        let isFirst = first;
        let importedSportIndex = index
      "
      [formGroup]="importedSport"
    >
      <app-form-checkbox
        class="block"
        [class.mt-3]="isFirst"
        [class.mt-2]="!isFirst"
        [label]="importedSport.value.sportOffer.name"
        formControlName="checked"
      ></app-form-checkbox>
    </ng-container>
  </fieldset>

  <span class="text-lg font-bold mt-3" *ngIf="!isFirstOffer">
    {{ translateKey('additional.title', { formula_title: offerName }) }}
  </span>

  <fieldset
    class="mt-3"
    *ngFor="
      let sport of sports.controls;
      let isFirst = first;
      let sportIndex = index
    "
    [formGroup]="sport"
  >
    <legend class="flex items-center w-full mb-3">
      <span class="text-lg font-bold">
        {{
          translateKey('legend.formula', {
            formula_number: this.sportsList?.length + sportIndex + 1,
          })
        }}
      </span>
      <button
        *ngIf="!isFirstOffer || (isFirstOffer && !isFirst)"
        app-vtmn-play-button
        type="button"
        class="ml-auto text-condensed text-neutral"
        [type]="ctaButtonType.Button"
        (click)="removeSport(sportIndex)"
      >
        {{ translateKey('remove_formula') }}
      </button>
    </legend>

    <app-form-input-group
      class="block mb-3"
      [label]="translateKey('input.name.label')"
      [errors]="getErrors('name', sportIndex)"
      errorKey="name"
    >
      <app-form-input
        #content
        formControlName="name"
        [placeholder]="translateKey('input.name.placeholder')"
        [required]="true"
      ></app-form-input>
    </app-form-input-group>

    <app-form-input-group
      class="block mb-3"
      [label]="translateKey('input.description.label')"
      [errors]="getErrors('description', sportIndex)"
      errorKey="description"
    >
      <app-form-textarea
        #content
        formControlName="description"
        [placeholder]="translateKey('input.description.placeholder')"
        [rows]="5"
        [required]="true"
      >
      </app-form-textarea>
    </app-form-input-group>

    <app-form-image
      formControlName="image"
      class="flex h-activity-creation-photo"
      [aspectRatio]="imageAspectRatio"
      [selectButtonText]="translateKey('upload.picture')"
      (change)="updateUpload(sportIndex)"
    >
    </app-form-image>
  </fieldset>
  <button
    app-vtmn-play-button
    type="button"
    class="mt-6 text-sm hover:underline"
    [type]="ctaButtonType.Button"
    (click)="addSport()"
  >
    {{ translateKey('add_sport') }}
  </button>

  <fieldset class="mt-4">
    <legend class="text-lg font-bold">
      {{ translateKey('legend.size') }}
    </legend>

    <app-input-counter
      formControlName="maximumSportSelectable"
      class="block mt-3"
      [max]="totalSportsNumber"
      [label]="translateKey('input.size.label')"
    ></app-input-counter>
  </fieldset>
</app-organizer-shared-form-wrapper>
